(function () {

  /* ── Scroll Reveal ─────────────────────────────────────────── */
  const reveals = document.querySelectorAll('.reveal');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  reveals.forEach(el => revealObserver.observe(el));

  /* ── Nav shadow on scroll ──────────────────────────────────── */
  const nav = document.querySelector('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.boxShadow = window.scrollY > 60
        ? '0 1px 20px rgba(0,0,0,0.06)'
        : 'none';
    }, { passive: true });
  }

  /* ── Inquiry Form — 送信直前にcontact[body]へ全フィールドを集約 ── */
  const form      = document.getElementById('inquiry-form');
  const bodyField = document.getElementById('inquiry-body');

  if (!form || !bodyField) return;

  form.addEventListener('submit', function (e) {

    const val = (id) => {
      const el = document.getElementById(id);
      return el ? (el.value || '').trim() : '';
    };
    const checkedRadio = (name) => {
      const el = form.querySelector('[name="' + name + '"]:checked');
      return el ? el.value : '-';
    };
    const checkedBoxes = (name) => {
      const els = form.querySelectorAll('[name="' + name + '"]:checked');
      return els.length ? Array.from(els).map(b => b.value).join(', ') : '-';
    };

    const company     = val('field-company');
    const name        = val('field-name');
    const jobTitle    = val('field-job-title');
    const email       = val('field-email');
    const stage       = checkedRadio('_stage');
    const reason      = checkedBoxes('_reason');
    const priority    = checkedRadio('_priority');
    const productType = val('field-product-type');
    const timeline    = checkedRadio('_timeline');
    const extra       = val('field-extra');

    const body = [
      '[ WIBE お問い合わせ受信 ]',
      '',
      '■ 会社名             : ' + (company     || '-'),
      '■ お名前             : ' + (name        || '-'),
      '■ 役職               : ' + (jobTitle    || '-'),
      '■ メールアドレス     : ' + (email       || '-'),
      '',
      '■ 海外展開ステージ               : ' + stage,
      '■ 韓国市場を検討する理由         : ' + reason,
      '■ 今回の検証で最も重視すること   : ' + priority,
      '■ 製品・サービスの種類           : ' + (productType || '-'),
      '■ 検証を想定している時期         : ' + timeline,
      '',
      '■ その他共有したいこと :',
      extra || '（なし）',
    ].join('\n');

    bodyField.value = body;
  });

})();
